import type { ProjectContext } from './ProjectContextPayload.types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { State } from './ProjectContextServiceActions.types.tsx';

type ProjectKey = string;

export const setProjectContext =
	(key: ProjectKey, projectContext: ProjectContext) =>
	({ setState }: StoreActionApi<State>): void => {
		// oxlint-disable-next-line typescript/consistent-type-assertions
		setState({ [key as string]: projectContext });
	};

export const mergeProjectProperty =
	(key: ProjectKey, projectContext: Partial<ProjectContext>) =>
	({ setState, getState }: StoreActionApi<State>): void => {
		const currentState = getState();
		const currentProjectContext = currentState[key];
		const newProjectContext = { ...currentProjectContext, ...projectContext };
		// oxlint-disable-next-line typescript/consistent-type-assertions
		setState({ [key as string]: newProjectContext });
	};
